// #region Imports

import type { ThemeGeneratorFactoryFn } from '../interfaces/IThemeGeneratorFactory';
import { LchThemeGeneratorStrategy } from './abstracts/LchThemeGeneratorStrategy';

// #endregion

/**
 * Memphis theme generator strategy.
 *
 * @remarks
 * Extends {@link LchThemeGeneratorStrategy} without customization.
 *
 * @public
 */
export class MemphisThemeGeneratorStrategy extends LchThemeGeneratorStrategy {

}

/**
 * Generates a Memphis theme generator strategy.
 *
 * @public
 */
export function createMemphisTheme(): ThemeGeneratorFactoryFn {
    const strategy = new MemphisThemeGeneratorStrategy();

    return () => strategy;
}
